type Grant = {
  customRoleId: string | null;
  builtinRoleId: string | null;
};

type GroupWithGrants = {
  id: string;
  roleGrantsAsPrincipal: readonly Grant[];
};

function countGrants(counts: Map<string, number>, grants: readonly Grant[]) {
  for (const gr of grants) {
    const key = gr.customRoleId ?? gr.builtinRoleId;
    if (key) counts.set(key, (counts.get(key) ?? 0) + 1);
  }
}

export function buildRoleGrantCounts(
  groups: readonly GroupWithGrants[],
  directUserGrants: readonly Grant[] = [],
  directServiceAccountGrants: readonly Grant[] = []
): Map<string, number> {
  const counts = new Map<string, number>();
  for (const g of groups) countGrants(counts, g.roleGrantsAsPrincipal);
  countGrants(counts, directUserGrants);
  countGrants(counts, directServiceAccountGrants);
  return counts;
}
